import { render, staticRenderFns } from "./BusinessCategoryList.vue?vue&type=template&id=6af8dbe6"
import script from "./BusinessCategoryList.vue?vue&type=script&lang=js"
export * from "./BusinessCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports